<template>
  <v-container class="mt-0 pt-0" fluid style="height:100%;">

    <v-row>
      <v-flex>
        <navbar></navbar>
      </v-flex>
    </v-row>

    <v-row class="justify-center">
       <div>
        <p class="changefont">Duck</p>
      </div>
    </v-row>

    <v-row class="justify-center">
      <v-flex lg6 md8 sm12 xs12>
        <v-card>
          <v-container class="py-0 px-0" fluid>
            <v-row>
              <v-col
                v-for="document in Documents()"
                :key="document.data().imageUrl"
                class="d-flex child-flex"
                cols="12"
              >
                <v-card flat tile >
                  <v-img
                    :src="document.data().imageUrl"
                    :lazy-src="document.data().imageUrl"
                    contain
                    class="grey lighten-2"
                  >
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-flex>
    </v-row>

  </v-container>
</template>
<script>

import Navbar from "@/components/Navbar.vue";

export default {
  components: {
    Navbar
  },
  methods: {
    Documents() {
      return this.$store.getters.getImages;
    },
  },
  beforeCreate(){
    this.$store.commit("getImage", 'Duck');
  }
};
</script>
<style>
.bg {
  height: 100%;
}
.changefont {
  font-size: 2rem;
  font-weight: bold;
  color: white;
  margin-bottom: 10px;
}
</style>